import { features } from "@/mocks/homeContent";

export default function FeaturesSection() {
  return (
    <section className="relative py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4">
            Features
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-4">
            What You Get Inside AllChinaBuySpreadsheet
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            Every spreadsheet is packed with structured, verified data designed to help you source products
            from China with confidence.
          </p>
        </div>

        {/* Feature Table */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-800 border-b border-background-200/70">
                  Feature
                </th>
                <th className="text-left px-5 py-4 text-sm font-semibold text-foreground-800 border-b border-background-200/70">
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {features.map((feat, idx) => (
                <tr
                  key={idx}
                  className={`border-b border-background-100 ${
                    idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"
                  }`}
                >
                  <td className="px-5 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-600">
                        <i className={`${feat.icon} text-sm`}></i>
                      </div>
                      <span className="text-sm font-medium text-foreground-800">{feat.title}</span>
                    </div>
                  </td>
                  <td className="px-5 py-4 text-sm text-foreground-600 leading-relaxed">
                    {feat.description}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}